<template>
    <div id="app">
        <HeaderComponent />
        <div class="router__container">
            <router-view
                class="content"
                :class="{ 'safe-bottom-space': $route.name !== 'Legal' }" />
        </div>
        <FooterComponent />
    </div>
</template>

<script>
import {importComponents, getIEVersion} from "@/utils";
import flexibility from "flexibility";
import _ from "lodash";

const {
    Header: HeaderComponent,
    Footer: FooterComponent
} = importComponents();

let App = {
    name: "app",
    components: {
        HeaderComponent,
        FooterComponent
    }
    /*
    created () {
        // this exchange would normally be initiated by a user/login.
        const getToken = (id, msg) => {
            // Webpack substitutes process.env values for the corresponding
            // configuration variables in /config, based on the environment
            const url = process.env.apiUrl + process.env.stage + "/login";
            // create a request with the fetch plugin, then pass it to the
            // action, enabling us to abort the request.
            return this.$store
                .dispatch("auth/getToken", this.$request
                    .fetch(url, {
                        method: "POST",
                        body: JSON.stringify({id}),
                        // optional timeout rejection
                        timeout: 3000
                    })
                )
                // store actions should always return a promise
                .then(_ => this.$store
                    .dispatch("demo/reflectMessage", msg)
                )
                .catch(console.error); // eslint-disable-line no-console
        };
        // this is a contrived example. See the auth store module for more..
        setTimeout(getToken, 50, "userB", "Welcome to your Vue.js app!");
        // this request will be aborted in favor of the above.
        getToken("userA", "this will be forgotten");
    }
    */
};

const ieVersion = getIEVersion();
if (ieVersion !== -1 && ieVersion < 11) {
    App = _.assign(App, {
        updated () {
            flexibility(document.body);
        }
    });
}

export default App;

</script>

<style lang="scss">
// import common rules for body text, headings, links, etc.
@import "assets/_mds_reset.scss";

$formBackgroundColor: #F2F2F2;

.router {
    &__container {
        background-color: $formBackgroundColor;
    }
}

.content {
    margin: auto;
    max-width: 1195px;
    overflow: auto;
    padding-bottom: $mds-font-size-s;
}

@media #{$bp-desktop} {
    .content {
        width: 100%;
    }

    .safe-bottom-space {
        padding-bottom: 120px;
    }
}

@media #{$bp-desktop-lg} {
    .content {
        width: 1000px;
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue